<template>
  <basic-container>
    <div class="custom-title">
      <div class="custom-block tip">
        <p class="custom-block-title">{{ title }}</p>
      </div>
      <div class="return-list">
        <el-button icon="el-icon-back" size="mini" @click="returnIndex('/source/website')"
          >返回列表</el-button
        >
      </div>
    </div>
    <!--展示地图区域-->
    <div class="amap-contain">
      <el-amap
        vid="amap"
        ref="map"
        :zoom="zoom"
        :center="center"
        :resize-enable="true"
        :events="events"
        class="map"
      >
        <el-amap-marker
          :position="marker.position"
          :visible="marker.visible"
          :label="{
            content: marker.label.content,
            offset: [-44, -16],
            direction: 'bottom'
          }"
          :draggable="marker.draggable"
          :plugin="plugin"
          vid="index"
        />

        <el-amap-polygon
          strokeColor="#FF0000"
          strokeOpacity="1"
          fillColor="#c9ebf7"
          fillOpacity="0.4"
          v-for="(polygon, index) in polygons"
          :key="index"
          strokeWeight="1"
          stroke-style="dashed"
          :events="polygonEvents"
          :path="polygon.path"
        />
      </el-amap>
    </div>
    <div class="website-contain">
      <el-card shadow="always">
        <el-form ref="form" label-width="93px" :model="form" :inline="true" :rules="rules">
          <el-col :span="20" class="form-style">
            <el-form-item label="站点名称:" prop="stationName">
              <el-input
                v-model="form.stationName"
                clearable
                placeholder="请输入站点名称"
                maxlength="15"
                show-word-limit
                style="width: 240px"
              />
            </el-form-item>
            <el-form-item label="业务类型:" prop="type">
              <YdBusinessTypeSelector
                v-model="form.type"
                :multiple="true"
                styles="width: 240px"
                @change="handleSelect"
              />
            </el-form-item>
            <el-form-item v-if="bizType.indexOf(3) !== -1" label="标签:" prop="stationType">
              <avue-select
                v-model="form.stationType"
                :dic="stationType"
                clearable
                multiple
                collapse-tags
                style="width: 240px"
                placeholder="请选择"
              />
            </el-form-item>
            <el-form-item label="行政区划:" prop="adcode">
              <YdCityLevelSelector
                v-model="form.adcode"
                styles="width: 240px"
                @change="handleChange"
                :showProvince="[]"
              />
            </el-form-item>

            <el-form-item label="详细地址:" prop="address">
              <custom-search-map
                ref="searchBox"
                v-model="form.address"
                :search-option="searchOption"
                style="width: 240px"
                :on-search-result="onSearchResult"
              />
            </el-form-item>

            <el-form-item label="地级归属：" prop="regionsId">
              <yd-city-select
                mode="1"
                v-model="form.regionsId"
                placeholder="试试搜索：请选择地级归属"
                @change="handleAreaChange"
                style="width: 230px"
              />
            </el-form-item>
          </el-col>
          <el-col class="btn-style">
            <el-form-item>
              <el-button type="danger" size="mini" @click.stop="cancel">取消</el-button>
              <el-button type="primary" size="mini" @click="handleSubmit">确定</el-button>
            </el-form-item>
          </el-col>
        </el-form>
      </el-card>
    </div>
  </basic-container>
</template>

<script>
  import customSearchMap from '@/components/custom-search-map'
  import { validatenull } from '@/util/validate'
  // import { selectTreeMixins } from '@/mixins/selectTree'
  import { saveSite, update, getInfo } from '@/api/source'
  let geocoder = null
  export default {
    name: 'webSiteInfo',
    // mixins: [selectTreeMixins],
    components: {
      customSearchMap
    },
    data() {
      return {
        title: '新增站点',
        // areaNames: [], // 省市区联动获取名称
        bizTypes: [],
        adcode: '',
        stationType: [
          { label: '普通站点', value: 1 },
          { label: '机场站点', value: 2 },
          { label: '火车站站点', value: 3 }
        ],
        typDic: [
          {
            label: '城际网约车',
            value: 1
          },
          {
            label: '同城网约车',
            value: 2
          },
          {
            label: '定点接送',
            value: 3
          },
          {
            label: '定制客运',
            value: 4
          },
          {
            label: '定制包车',
            value: 5
          },
          {
            label: '汽车租赁',
            value: 6
          },
          {
            label: '代驾',
            value: 7
          },
          {
            label: '小件快运',
            value: 8
          }
        ],
        form: {
          stationName: '',
          areaCode: '',
          adcode: '',
          id: 0,
          type: '',
          stationType: [],
          city: '',
          address: '',
          longitude: 0,
          latitude: 0,
          regionsId: '',
          areaManageId: undefined
        },
        rules: {
          stationName: [{ required: true, message: '站点名称不能为空', trigger: 'blur' }],
          type: [{ required: true, message: '业务类型不能为空', trigger: 'blur' }],
          stationType: [{ required: true, message: '标签不能为空', trigger: 'blur' }],
          adcode: [{ required: true, message: '请选择省市区', trigger: 'blur' }],
          address: [{ required: true, message: '详细地址不能为空', trigger: 'blur' }],
          regionsId: [{ required: true, message: '请选择地级归属', trigger: 'blur' }]
        },
        searchOption: {
          city: '',
          citylimit: false
        },
        zoom: 14,
        center: [102.719273, 25.011719],
        marker: {
          position: [102.719273, 25.011719],
          visible: true,
          draggable: false,
          icon: '//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png',
          constent: '',
          label: {
            content: '',
            offset: [-44, -16],
            direction: 'bottom'
          }
        },
        events: {
          moveend: () => {},
          zoomchange: () => {},
          click: (e) => {
            const that = this
            self.center = [e.lnglat.lng, e.lnglat.lat]
            geocoder.getAddress(self.center, function (status, result) {
              // 根据坐标获取位置
              if (status === 'complete' && result.info === 'OK') {
                self.input = result.regeocode.formattedAddress
              }
            })
            if (!validatenull(self.input)) {
              that.$refs.searchBox.keyword = self.input
              that.form.address = self.input
              that.form.longitude = e.lnglat.lng
              that.form.latitude = e.lnglat.lat
              that.marker.position = [e.lnglat.lng, e.lnglat.lat]
              that.marker.label.content = self.input
            }
          }
        },
        plugin: [
          {
            enableHighAccuracy: true, // 是否使用高精度定位，默认true
            timeout: 100, // 超过10秒后停止定位，默认：无穷大
            convert: true, // 自动偏移后的坐标为高德坐标，默认：true
            showButton: true, // 显示定位按钮，默认：true
            buttonPosition: 'RB', // 定位按钮停靠位置，默认'LB'，左下角
            showMarker: true, // 定位成功后在定位到的位置显示标记，默认：true
            showCircle: true, // 定位成功后用圆圈表示定位精度范围，默认：true
            panToLocation: true, // 定位成功后将定位到的位置作为地图中心点，默认true
            zoomToAccuracy: true, // 定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
            extensions: 'all',
            pName: 'Geocoder',
            events: {
              init() {
                // self.center 具体坐标 （数组格式） ，function 回调函数
                geocoder.getAddress(self.center, function (status, result) {
                  if (status === 'complete' && result.info === 'OK') {
                    // result.regeocode.formattedAddress就是具体位置
                    self.input = result.regeocode.formattedAddress
                    // 对搜索组件的input进行赋值
                    self.$refs.searchBox.keyword = self.input
                  }
                })
              }
            }
          },
          {
            showMarker: true, // 定位成功后在定位到的位置显示点标记，默认：true
            pName: 'Geolocation', // AMap-Geolocation 定位插件
            events: {
              init(o) {
                // 注意 虽然进页面就会调用这个方法，但是data()中center要有默认值，不然会报错
                o.getCurrentPosition((status, result) => {
                  if (result && result.position) {
                    const lng = result.position.lng
                    const lat = result.position.lat
                    self.center = [lng, lat]
                    self.loaded = true
                    self.zoom = 14
                    self.$nextTick()
                  }
                })
              }
            }
          }
        ],
        polygons: [],
        district: null,
        // 覆盖物点击事件
        polygonEvents: {
          click: (e) => {
            const that = this
            self.center = [e.lnglat.lng, e.lnglat.lat]
            geocoder.getAddress(self.center, function (status, result) {
              // 根据坐标获取位置
              if (status === 'complete' && result.info === 'OK') {
                self.input = result.regeocode.formattedAddress
              }
            })
            if (!validatenull(self.input)) {
              that.$refs.searchBox.keyword = self.input
              that.form.address = self.input
              that.form.longitude = e.lnglat.lng
              that.form.latitude = e.lnglat.lat
              that.marker.position = [e.lnglat.lng, e.lnglat.lat]
              that.marker.label.content = self.input
            }
          }
        }
      }
    },
    computed: {
      // city() {
      //   const city = []
      //   this.areaNames.forEach((item) => {
      //     city.push(item)
      //   })
      //   return city.filter((p, index) => index !== 0).join('/')
      // },
      // 选中的类型计算属性
      bizType() {
        const ids = []
        if (this.bizTypes && this.bizTypes.length > 0) {
          this.bizTypes.forEach((item) => {
            ids.push(item)
          })
        }
        return ids.join(',')
      }
    },
    mounted() {
      this.$nextTick(() => {
        if (window.AMap.Geocoder) {
          geocoder = new window.AMap.Geocoder({ radius: 1000, extensions: 'all' })
        }
      })
      setTimeout(() => {
        this.drawBounds(() => {}, this.form.adcode)
      }, 3000)
      const siteId = this.$route.params && this.$route.params.id
      if (siteId) {
        this.title = '编辑站点'
        this.getSite(siteId)
      }
    },
    methods: {
      // 获取详情
      getSite(id) {
        getInfo(id).then((resp) => {
          const { code, data } = resp
          if (code === 0) {
            this.form = data
            const {
              type,
              stationType = '',
              address,
              areaCode,
              longitude,
              latitude,
              areaManageId,
              stationName
            } = data
            if (type) {
              const types = type.split(',').map((item) => parseInt(item, 10))
              this.form.stationType = stationType
                ? stationType.split(',').map((item) => parseInt(item, 10))
                : []
              this.form.type = types
              this.bizTypes = types
            }
            this.$refs.searchBox.keyword = address
            this.form.adcode = parseInt(areaCode)
            this.center = [longitude, latitude]
            this.marker.position = [longitude, latitude]
            this.marker.label.content = stationName
            this.form.regionsId = areaManageId
            this.form.areaManageId = parseInt(areaManageId)
            this.form.stationName = stationName
          }
        })
      },
      // 点击搜索后触发的事件
      onSearchResult(pois) {
        if (pois.length > 0) {
          this.$nextTick(() => {
            this.$refs.searchBox.keyword = pois[0].name
          })
        }
        // 这边类似模糊查询 会返回一个数组
        this.center = [pois[0].lng, pois[0].lat]
        this.marker.position = [pois[0].lng, pois[0].lat]
        this.form.longitude = pois[0].lng.toString()
        this.form.latitude = pois[0].lat.toString()
      },
      // 联动选择
      handleChange(val) {
        const { pathLabels = [], value } = val || {}
        // this.areaNames = pathLabels
        this.form.areaCode = value
        this.form.city = pathLabels.filter((item, index) => index !== 0).join('/')
        if (value) {
          this.drawBounds(value)
        }
      },
      handleSelect(val) {
        this.bizTypes = val
      },
      handleAreaChange(val) {
        this.form.areaManageId = Number.parseInt(val[val.length - 1])
      },
      drawBounds(adcode) {
        const that = this
        that.AMap = window.AMap
        // 加载行政区划插件
        if (!that.district) {
          // 实例化DistrictSearch
          const opts = {
            subdistrict: 0, // 获取边界不需要返回下级行政区
            extensions: 'all', // 返回行政区边界坐标组等具体信息
            level: 'city' // 查询行政级别为 市
          }
          that.district = new that.AMap.DistrictSearch(opts)
        }
        // 行政区查询
        const code = adcode === null ? '530000' : adcode.toString()
        that.district.search(code, function (status, result = {}) {
          const bounds =
            result.districtList && result.districtList.length > 0
              ? result.districtList[0].boundaries
              : []
          if (bounds.length > 0) {
            for (let i = 0; i < bounds.length; i++) {
              // 生成行政区划polygon
              const polygon = new that.AMap.Polygon({
                strokeWeight: 1,
                path: bounds[i],
                fillOpacity: 0.4,
                fillColor: '#80d8ff',
                strokeColor: '#0091ea',
                strokeStyle: 'dashed'
              })
              that.polygons.push(polygon)
            }
          }
          that.AMap.Polygon.bind(that.polygons)
          that.$refs.map.$amap && that.$refs.map.$amap.setFitView(that.polygons) // 视口自适应
        })
      },

      // 保存或编辑
      handleSubmit() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            // const newCity = this.$refs.cascaderAddr.getCheckedNodes()[0].pathLabels
            // if (newCity.length === 3) {
            //   this.form.city = `${newCity[1]}${newCity[2]}`
            // } else {
            //   this.form.city = newCity[1]
            // }
            if (this.form.id !== 0) {
              // if (this.city === null) {
              // this.form.city = this.city
              // }
              if (this.bizType !== null) {
                this.form.type = this.bizType
              }
              update(this.form).then((res) => {
                if (res.code === 0) {
                  this.$message.success('修改成功')
                  this.$refs.form.resetFields()
                  this.returnIndex('/source/website')
                }
              })
            } else {
              // this.form.city = this.city
              this.form.type = this.bizType
              if (this.form.longitude === 0 && this.form.latitude === 0) {
                this.$message.error('请标记坐标点')
                return
              }
              saveSite(this.form).then((res) => {
                if (res.code === 0) {
                  this.$message.success('添加成功')
                  this.$refs.form.resetFields()
                  this.returnIndex('/source/website')
                }
              })
            }
          }
        })
      },
      // 取消
      cancel() {
        this.form.type = []
        this.bizTypes = []
        this.form.areaManageId = ''
        this.$refs.form.resetFields()
        this.$refs.searchBox.keyword = ''
        this.returnIndex('/source/website')
      },
      // 返回
      returnIndex(url) {
        this.$router.push({ path: url, query: { type: 'Refresh' } })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .custom-title {
    display: -webkit-flex; /* Safari */
    display: flex;
    justify-content: space-between;
    width: 100%;
    .custom-block.tip {
      border-color: #409eff;
      padding: 0.4rem 0 0 0.5rem;
      border-left-width: 0.3rem;
      border-left-style: solid;
      height: 26px;
      margin: 0rem 0;
    }
    .custom-block-title {
      font-weight: 600;
      margin: 0;
    }
    .return-list {
      justify-content: flex-end;
    }
  }
  .amap-contain {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    width: 100%;
    height: 120vh;
    display: flex;
    margin-top: 20px;

    .map {
      width: 100%;
      height: 120vh;
    }
  }

  .website-contain {
    position: absolute;
    left: 50px;
    top: 90px;
    width: 60vh;
    display: flex;
    flex-direction: column;
  }
  .form-style {
    padding: 10px 0 0 10px;
  }
  .btn-style {
    padding: 0 0 0 94px;
  }
</style>
